import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import { criticsSuggestionsAdminContext } from "../../../context/Admin/CriticsSuggestionsAdminContext/CriticsSuggestionsAdminContext";

const CriticsSuggestionsAdmin = () => {
  const {
    criticsSuggestions,
    criticsSuggestion,
    setCriticsSuggestion,
    totalCount,
    pageNumber,
    setPageNumber,
    limit,
    setLimit,
    handleGetCriticsSuggestions,
    handleEditCriticsSuggestion,
  } = useContext(criticsSuggestionsAdminContext);

  useEffect(() => {
    handleGetCriticsSuggestions();
  }, [pageNumber, limit]);

  return (
    <>
      <SiteTitle title="انتقادات و پیشنهادات" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "انتقادات و پیشنهادات", type: "a" },
        ]}
        title="لیست انتقادات و پیشنهادات"
      />

      <CardLayout>
        {isEmpty(criticsSuggestions) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center mt-2">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div className="mb-2">
                تعداد کل :{" "}
                <span className="badge badge-primary font-weight-bold">
                  {totalCount}
                </span>
              </div>
              <div>
                <select
                  className="form-control mb-2"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                  <option value={200} selected={200 === limit}>
                    200
                  </option>
                  <option value={400} selected={400 === limit}>
                    400
                  </option>
                  <option value={700} selected={700 === limit}>
                    700
                  </option>
                  <option value={1000} selected={1000 === limit}>
                    1000
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>نام کامل</th>
                  <th>شماره موبایل</th>
                  <th>پست الکترونیک</th>
                  <th>تاریخ ایجاد</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {criticsSuggestions.map((_item, index) => (
                  <tr className={`${_item.view ? "" : "table-info"}`}>
                    <td>{index + 1}</td>
                    <td>{_item.name}</td>
                    <td>{_item.mobile}</td>
                    <td>{_item.email}</td>
                    <td>{_item.created_time}</td>
                    <td className="mw-25">
                      <button
                        onClick={() => setCriticsSuggestion(_item)}
                        className="btn btn-primary mr-2"
                      >
                        مشاهده
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`جزئیات انتقاد و پیشنهاد ${criticsSuggestion?.name}`}
        show={!isEmpty(criticsSuggestion)}
        onHide={() => setCriticsSuggestion({})}
        size="lg"
      >
        <div className="row">
          <ItemInfo label="نام کامل">
            <p>{criticsSuggestion?.name}</p>
          </ItemInfo>
          <ItemInfo label="شماره موبایل">
            <p>{criticsSuggestion?.mobile}</p>
          </ItemInfo>
          <ItemInfo label="پست الکترونیک">
            <p>{criticsSuggestion?.email}</p>
          </ItemInfo>
          <ItemInfo label="تاریخ ایجاد">
            <p>{criticsSuggestion?.created_time}</p>
          </ItemInfo>
          <ItemInfo label="توضیحات" grid="col-12">
            <p className="pre_wrap-white_space">
              {criticsSuggestion?.description}
            </p>
          </ItemInfo>
        </div>
        {!criticsSuggestion.view && (
          <div className="text-right">
            <button
              className="btn btn-primary"
              onClick={handleEditCriticsSuggestion}
            >
              خوانده شد
            </button>
          </div>
        )}
      </CustomModal>
      {/* End Create Modal */}
    </>
  );
};

export default CriticsSuggestionsAdmin;
